import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "padding": "1rem"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    title: "联系方式",
    style: {
      "background-color": "lightblue"
    }
  }), _createElementVNode("div", {
    style: _normalizeStyle([{
      "padding": "0rem",
      "text-align": "center",
      "background-color": "aliceblue"
    }, {
      'minHeight': $data.viewhight + 'px'
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: "/img/connect.jpg",
    width: "100%",
    height: "200",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.preview && $options.preview(...args))
  })])], 4)]);
}